
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Header extends Vue {
  @Prop({ type: Boolean, default: false }) public isCollected;
  public isIOs = false;
  public change() {
    this.$emit("collectChange");
  }
  public mounted() {
    //   url截取token
    // const obj: any = this.$fn.parseQuery(window.location.href);
    if (this.$fn.cookies.getIsios()) {
      this.isIOs = true;
    }
  }
  public onClickLeft() {
    this.$router.go(-1);
  }
}
